package ui.icons

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit
import org.jetbrains.compose.web.dom.AttrBuilderContext
import org.w3c.dom.HTMLDivElement

@Composable
fun Check(
    attrs: AttrBuilderContext<HTMLDivElement>? = null,
    size: CSSSizeValue<CSSUnit.px> = DEFAULT_ICON_SIZE,
) =
    Icon(attrs, size = size) {
      attr(
          "d",
          "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z",
      )
    }
